module.exports = __webpack_public_path__ + "img/Bonjour DAO.5d4b8fcc.svg";